import React from "react";
// Rutas
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
// SEO
import { HelmetProvider, Helmet } from "react-helmet-async";
// Páginas
import Home from "./pagesSammy/Home";
import About from "./pagesSammy/About";
import Contact from "./pagesSammy/Contact";
import HomePeople from "./pagesPeopletech/HomePeople";
import AboutPeople from "./pagesPeopletech/AboutPeopletech";
import ContactPeople from "./pagesPeopletech/ContactPeopletech";
import BlogPeople from "./pagesPeopletech/BlogPeople";
import BlogVideoPage from "./pagesPeopletech/BlogVideoPage";
import SEOExample from "./pagesPeopletech/SEOExample";
import ComingSoonService from "./pagesPeopletech/ComingSoonService";
import TermsOfService from "./pagesPeopletech/TermsOfService";
import PrivacyPolicy from "./pagesPeopletech/PrivacyPolicy";
import CookiePolicy from "./pagesPeopletech/CookiePolicy";
import LoginCrm from "./pagesPeopletech/LoginCrm";
import CrmDashboard from "./pagesPeopletech/CrmDashboard";
import CrmBookingsCalendar from "./pagesPeopletech/CrmBookingsCalendar";
import TestPage from "./pagesPeopletech/TestPage";
import GeoTestPeopleForTech from "./pagesPeopletech/GeoTestPeopleForTech";
import HomeLegacy from "./pagesLegacy/HomeLegacy";
import HomeProyectum from "./pagesProyectum/HomeProyectum";
import HomePeopleV2 from "./pagesPeopletech/v2/HomePeopleV2";
import ContactPeopleV2 from "./pagesPeopletech/v2/ContactPeopleV2";
import BookingPage from "./pagesPeopletech/v2/BookingPage";
import AcceptBookingPage from "./pagesPeopletech/v2/AcceptBookingPage";
// Componentes
import Navbar from "./components/Navbar";
import NavbarP from "./componentsPeopletech/NavbarP";
import NavbarPv2 from "./componentsPeopletech/v2/NavbarPv2";
import NavbarL from "./componentsLegacy/NavbarL";
import NavbarPr from "./componentsProyectumcopy/NavbarPr";
import HomeObraSonora from "./componentsObraSonora/Home.jsx";
import CookieBanner from "./components/CookieBanner";
function App() {
  // Obtiene la ubicación actual de la ruta para renderizar condicionalmente los componentes
  const location = useLocation();
  const baseUrl = "https://www.peoplefortech.com";

  const getGlobalSeo = (pathname) => {
    const normalizedPathname =
      pathname && pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;

    // Defaults (safe fallbacks in case page-level Helmet doesn't render in prerender)
    const defaults = {
      title: "PeopleForTech",
      canonical: `${baseUrl}${normalizedPathname === "/" ? "/" : normalizedPathname}`,
      robots: "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"
    };

    if (
      normalizedPathname.startsWith("/crm") ||
      normalizedPathname.startsWith("/login") ||
      normalizedPathname.startsWith("/test")
    ) {
      return { ...defaults, robots: "noindex,follow" };
    }
    if (
      normalizedPathname.startsWith("/legacy") ||
      normalizedPathname.startsWith("/proyectum") ||
      normalizedPathname.startsWith("/paisajessonorosdelnoa")
    ) {
      return { ...defaults, robots: "noindex,follow" };
    }

    if (normalizedPathname === "/")
      return {
        ...defaults,
        title: "PeopleForTech - AI Advisory, AI Implementation & GEO",
        canonical: `${baseUrl}/`
      };
    if (normalizedPathname === "/about") return { ...defaults, title: "About - PeopleForTech" };
    if (normalizedPathname === "/contact") return { ...defaults, title: "Contact - PeopleForTech" };
    if (normalizedPathname === "/blog") return { ...defaults, title: "Blog - PeopleForTech" };
    if (normalizedPathname.startsWith("/blog/")) return { ...defaults, title: "Blog - PeopleForTech" };
    if (normalizedPathname === "/geo-para-chatgpt-gemini")
      return { ...defaults, title: "GEO for ChatGPT & Gemini - PeopleForTech" };
    if (normalizedPathname === "/geo-test") return { ...defaults, title: "PeopleForTech GEO Test - Verify AI visibility" };
    if (normalizedPathname === "/peoplefortech/v2")
      return { ...defaults, title: "AI Advisory & Implementation - PeopleForTech" };
    if (normalizedPathname === "/peoplefortech/v2/contact")
      return { ...defaults, title: "Contact - PeopleForTech v2" };
    if (normalizedPathname === "/peoplefortech/v2/reserva")
      return { ...defaults, title: "Book your consultation - PeopleForTech" };
    if (normalizedPathname === "/terms-of-service")
      return { ...defaults, title: "Terms of Service - PeopleForTech", robots: "noindex,follow" };
    if (normalizedPathname === "/privacy-policy")
      return { ...defaults, title: "Privacy Policy - PeopleForTech", robots: "noindex,follow" };
    if (normalizedPathname === "/cookie-policy")
      return { ...defaults, title: "Cookie Policy - PeopleForTech", robots: "noindex,follow" };

    return defaults;
  };

  const globalSeo = getGlobalSeo(location.pathname);

  /**
   * Función que determina qué Navbar renderizar según la ruta actual
   * - /sammy/* -> Navbar de Sammy
   * - / (raíz) -> Navbar de PeopleTech
   * - /legacy/* -> Navbar de Legacy
   * - /proyectum/* -> Navbar de Proyectum
   * - /paisajessonorosdelnoa/* -> Fragmento vacío (sin Navbar)
   * - Otros -> null (sin Navbar)
   */
  const renderNavbar = () => {
    // Verificar rutas específicas primero (orden de más específico a menos específico)
    if (location.pathname.startsWith("/sammy")) {
      return <Navbar />;
    } else if (location.pathname.startsWith("/legacy")) {
      return <NavbarL />;
    } else if (location.pathname.startsWith("/proyectum")) {
      return <NavbarPr />;
    } else if (location.pathname.startsWith("/paisajessonorosdelnoa")) {
      return <React.Fragment/>;
    } else if (location.pathname.startsWith("/peoplefortech/v2") || location.pathname.startsWith("/v2") || location.pathname.startsWith("/reserva")) {
      // PeopleForTech v2 - nueva versión con foco Asesoramiento IA
      return <NavbarPv2 />;
    } else if (location.pathname === "/" || location.pathname.startsWith("/about") || location.pathname === "/contact" || location.pathname.startsWith("/blog") || location.pathname.startsWith("/geo-para-chatgpt-gemini") || location.pathname.startsWith("/geo-test") || location.pathname.startsWith("/seo-example") || location.pathname.startsWith("/coming-soon") || location.pathname.startsWith("/terms-of-service") || location.pathname.startsWith("/privacy-policy") || location.pathname.startsWith("/cookie-policy") || location.pathname.startsWith("/test")) {
      // Ruta raíz o rutas de PeopleTech
      return <NavbarP />;
    } else if (location.pathname.startsWith("/login") || location.pathname.startsWith("/crm")) {
      // Rutas de CRM - sin navbar
      return null;
    } else {
      return null; // Opcionalmente, puedes renderizar un Navbar por defecto aquí
    }
  };

  // El SEO ahora se maneja con react-helmet-async en cada página/componente

  return (
    <>
      <Helmet>
        <title>{globalSeo.title}</title>
        <link rel="canonical" href={globalSeo.canonical} />
        <meta name="robots" content={globalSeo.robots} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "PeopleForTech",
            "alternateName": "PXT",
            "url": baseUrl,
            "logo": `${baseUrl}/favicon.ico`,
            "email": "contact@peoplefortech.com",
            "sameAs": ["https://www.tiktok.com/@peoplefortech", "https://www.instagram.com/people_for_tech/"]
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "PeopleForTech",
            "url": baseUrl,
            "inLanguage": "en",
            "publisher": { "@type": "Organization", "name": "PeopleForTech", "url": baseUrl }
          })}
        </script>
      </Helmet>
      {/* Renderiza el Navbar solo si no estamos en la ruta de paisajessonorosdelnoa */}
      {!location.pathname.startsWith("/paisajessonorosdelnoa") && renderNavbar()}
      <CookieBanner />
      <Routes>
        {/* Rutas para SAMMY */}
        <Route path="/sammy/about" element={<About />} />
        <Route path="/sammy/home" element={<Home />} />
        <Route path="/sammy/contact" element={<Contact />} />
        
        {/* Ruta para Paisajes Sonoros del NOA - Sin Navbar */}
        <Route path="/paisajessonorosdelnoa" element={<HomeObraSonora />} />
        
        {/* Rutas para PeopleTech (ruta raíz) */}
        <Route path="/" element={<HomePeople />} />
        <Route path="/about" element={<AboutPeople />} />
        <Route path="/blog" element={<BlogPeople />} />
        <Route path="/blog/:slug" element={<BlogVideoPage />} />
        <Route path="/contact" element={<ContactPeople />} />
        {/* PeopleForTech v2 - foco Asesoramiento + Implementación IA */}
        <Route path="/v2" element={<Navigate to="/peoplefortech/v2" replace />} />
        <Route path="/v2/contact" element={<Navigate to="/peoplefortech/v2/contact" replace />} />
        <Route path="/peoplefortech/v2" element={<HomePeopleV2 />} />
        <Route path="/peoplefortech/v2/contact" element={<ContactPeopleV2 />} />
        <Route path="/peoplefortech/v2/reserva" element={<BookingPage />} />
        <Route path="/reserva" element={<Navigate to="/peoplefortech/v2/reserva" replace />} />
        <Route path="/reserva/accept/:id" element={<AcceptBookingPage />} />
        <Route path="/geo-para-chatgpt-gemini" element={<SEOExample />} />
        <Route path="/seo-example" element={<Navigate to="/geo-para-chatgpt-gemini" replace />} />
        <Route path="/geo-test" element={<GeoTestPeopleForTech />} />
        <Route path="/coming-soon" element={<ComingSoonService />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        
        {/* CRM Routes */}
        <Route path="/login" element={<LoginCrm />} />
        <Route path="/crm/dashboard" element={<CrmDashboard />} />
        <Route path="/crm/reservas" element={<CrmBookingsCalendar />} />
        
        {/* Test Route */}
        <Route path="/test" element={<TestPage />} />

        {/* Rutas para Legacy */}
        <Route path="/legacy/home" element={<HomeLegacy />} />

        {/* Rutas para Proyectum */}
        <Route path="/proyectum/home" element={<HomeProyectum />} />
      </Routes>
    </>
  );
}

// Envuelve tu App en BrowserRouter y HelmetProvider
export default function WrappedApp() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  );
}
